import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, deleteToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app = null;
let messaging = null;

// Firebase 초기화 (config가 있을 때만)
if (firebaseConfig.apiKey) {
  app = initializeApp(firebaseConfig);
  // Safari/iOS에서 messaging 지원 안 할 수 있으므로 try-catch
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.warn('[Firebase] Messaging not supported:', e.message);
  }
}

export { app, messaging, getToken, deleteToken, onMessage };
